import React, { useEffect, useState } from 'react'
import { useChatDispatch, useChatInitialization, useChatState } from '../../state/ChatState'
import api from '../../api/chat'
import * as handlers from '../../global/chatHandlers'
import { Chat } from '../../global/chatSettingsConfig'
import chatLog from '../../global/chat-log'

const GlobalChatListener = ({ fsUser }) => {
  const { connection, chatEnabled } = useChatState()
  const dispatch = useChatDispatch()
  const [hasRegistered, setHasRegistered] = useState(false)
  const [previousChatEnabled, setPreviousChatEnabled] = useState(false)

  useChatInitialization({ fsUser })

  const [onMessageCallback] = handlers.useOnMessageHandler()
  const [onGroupMessageCallback] = handlers.useOnMessageHandler()
  const [onPresenceCallback] = handlers.useOnPresenceHandler()
  const [onInvitationCallback] = handlers.useOnInvitationHandler()
  const [autoJoinRooms] = handlers.useAutoJoinRooms()

  const canProceed = fsUser?.signedIn && connection && dispatch && chatEnabled

  // Handle cases where they turn off/on chat.
  useEffect(() => {
    if (previousChatEnabled && !chatEnabled) {
      setHasRegistered(false)
      setPreviousChatEnabled(false)
    }
  }, [chatEnabled, previousChatEnabled])

  useEffect(() => {
    if (canProceed) {
      if (!hasRegistered) {
        // 1. Start listening for new chat messages BEFORE you tell the server you're online
        connection.addHandler(onMessageCallback, null, 'message', 'chat')

        // 2. Listen for group chats
        connection.addHandler(onGroupMessageCallback, null, 'message', 'groupchat')

        // 3. Listen for group chat invitations
        connection.addHandler(onInvitationCallback, Chat.NS.XCONFERENCE, 'message')

        // 4. Listen for presence notifications and tell the server you're online
        connection.addHandler(onPresenceCallback, null, 'presence')

        // 5. tell the server we are online. The server will now send us current
        // presence of my roster! For free! We don't have to ask for them.
        // NOTE: I also think this fixes RTC-955 where now we can catch the messages that are sent to us.
        api.profile.enableNofificationsFromServer({ connection })

        // 6. Declare your presence in each chat room (autoJoin flag)
        autoJoinRooms()
        chatLog(`Finished registering handlers.`)
        setHasRegistered(true)
        setPreviousChatEnabled(true)
      } else {
        chatLog(`Handlers have already been registered. Skipping.`)
      }
    } else if (!fsUser.userLoading && !fsUser.cisId) {
      dispatch({ type: 'IS_NOT_LOGGED_IN' })
    }
  }, [
    canProceed,
    connection,
    dispatch,
    fsUser.cisId,
    fsUser.userLoading,
    onMessageCallback,
    onPresenceCallback,
    onInvitationCallback,
    autoJoinRooms,
    onGroupMessageCallback,
    hasRegistered,
    chatEnabled,
  ])

  return <div />
}

export default GlobalChatListener
